<ng-template #menuitem let-item let-root="root">
  @if (item.routerLink) {
    <a
      [routerLink]="item.routerLink"
      [routerLinkActive]="'text-primary-800'"
      class="p-3 flex flex-row flex-nowrap cursor-pointer items-center"
      pRipple>
      <ng-template [ngTemplateOutlet]="content" />
    </a>
  } @else if (item.url) {
    <a [href]="item.url" class="p-3 flex flex-row flex-nowrap cursor-pointer items-center" pRipple>
      <ng-template [ngTemplateOutlet]="content" />
    </a>
  } @else {
    <a class="p-3 flex flex-row flex-nowrap cursor-pointer items-center" pRipple>
      <ng-template [ngTemplateOutlet]="content" />
    </a>
  }
  <ng-template #content>
    @if (item.icon === 'var-healthcare-portal') {
      <img alt="VAR Healthcare Portal" height="20" i18n-alt ngSrc="assets/VAR_icon.png" width="20" />
    } @else if (item.icon) {
      <fa-icon [icon]="item.icon"></fa-icon>
    }
    <span [class]="item.styleClass" class="ml-2">{{ item.label }}</span>
    @if (item.badge) {
      <p-badge [value]="item.badge" class="ml-2" />
    }
    @if (item.items) {
      <fa-icon [icon]="root ? 'chevron-down' : 'chevron-right'" class="ml-2"></fa-icon>
    }
  </ng-template>
</ng-template>

<div class="bg-surface-0 border-b border-surface flex flex-col flex-auto items-center">
  <div class="px-3 py-2 w-full max-w-container">
    <p-menubar
      [baseZIndex]="1000"
      [model]="items()"
      [style]="{ border: 'none', 'background-color': 'transparent', padding: 0 }"
      #menubar>
      <ng-template #start>
        <img alt="tacs® Logo" class="mr-2" height="33" i18n-alt ngSrc="assets/tacs_text.svg" priority width="94" />
      </ng-template>
      <ng-template #menuicon>
        <fa-icon class="text-2xl" icon="bars"></fa-icon>
      </ng-template>

      <ng-template #item let-menuItem>
        <ng-template [ngTemplateOutlet]="menuitem" [ngTemplateOutletContext]="{ $implicit: menuItem }" />
      </ng-template>

      <ng-template #end>
        <div class="flex h-full">
          @if (hasNewVersion()) {
            <a
              (click)="doUpdate.emit()"
              class="px-2 flex items-center text-green-600 hover:text-surface-950 hover:bg-surface-100 rounded-border cursor-pointer transition-colors duration-150"
              i18n-pTooltip
              pTooltip="Neue Version verfügbar. Hier klicken um zu aktualisieren."
              role="button"
              tabindex="0"
              tooltipPosition="bottom">
              <fa-icon class="sm:text-xl" icon="rotate-right" />
            </a>
          }
          @if (isSaving() && isOnline()) {
            <span
              class="px-2 flex items-center font-medium rounded-border text-orange-600"
              i18n-pTooltip
              pTooltip="Daten werden gespeichert"
              tooltipPosition="bottom">
              <fa-icon [animation]="'spin'" icon="rotate" />
            </span>
          }
          @if (!isOnline()) {
            <span class="px-2 flex items-center rounded-border text-orange-600">
              <fa-icon icon="wifi-slash" />
            </span>
          }
          @if (varHealthcareBaseUri) {
            <a
              [href]="varHealthcareBaseUri"
              class="px-2 hidden lg:flex flex-row flex-nowrap cursor-pointer hover:bg-surface-100 rounded items-center"
              target="_blank">
              <img alt="VAR Healthcare Portal" height="24" i18n-alt ngSrc="assets/VAR_icon.png" width="24" />
            </a>
          }
          <a
            [href]="manualUrl()"
            class="px-2 hidden lg:flex flex-row flex-nowrap cursor-pointer hover:bg-surface-100 rounded items-center"
            download>
            <fa-icon class="sm:text-xl" icon="question-circle" />
          </a>
          <a
            (click)="language.toggle($event)"
            class="px-2 hidden lg:flex flex-row flex-nowrap cursor-pointer hover:bg-surface-100 rounded items-center"
            role="button"
            tabindex="0">
            <fa-icon class="sm:text-xl" icon="language" />
            <p-menu [model]="languageMenuItems" [popup]="true" #language appendTo="body"></p-menu>
          </a>
          <a
            (click)="menu.toggle($event)"
            class="pl-2 flex flex-row flex-nowrap cursor-pointer hover:bg-surface-100 rounded gap-2 items-center"
            role="button"
            tabindex="0">
            <span class="hidden sm:block">{{ fullname }}</span>
            <p-avatar [image]="avatarUrl" class="cursor-pointer" shape="circle" />
          </a>
          <p-menu [model]="avatarItems()" [popup]="true" #menu appendTo="body">
            <ng-template #item let-menuItem>
              <ng-template [ngTemplateOutlet]="menuitem" [ngTemplateOutletContext]="{ $implicit: menuItem }" />
            </ng-template>
          </p-menu>
        </div>
      </ng-template>
    </p-menubar>
  </div>
</div>
